import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RiHeaderModule } from '../ri-header/ri-header.module'
import { NotificationsRoutingModule, routableModules } from './notifications-routing.module';
import { NotificationsComponent } from './notifications.component';
import { GrayBarHeaderModule } from '../common/component/gray_bar_header/gray_bar_header.module';

@NgModule({
  imports: [
    CommonModule
    ,NotificationsRoutingModule
    ,RiHeaderModule
    ,routableModules
    ,GrayBarHeaderModule
  ],
  declarations: [NotificationsComponent],
  exports: [NotificationsComponent]
})
export class NotificationsModule { }
